import PageWhitelistUtils from "./pageWhitelistUtils"
import utils from "../utils/utils"
import { store } from '@/store/store'

export default class PageLinkUtils {
    getViestintaLinks(): Array<any> {
        const pageUtils = new PageWhitelistUtils()
        const linkArray: Array<any> = []

        if (pageUtils.isMenuOnWhiteList("LaajakaistaJaPuhelin")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.Header.Viestinta.LaajakaistaJaPuhelin"
            })
        }

        if (pageUtils.isMenuOnWhiteList("Posti")) {
            linkArray.push({
                to: "/Viestinta/Posti",
                pageName: "Posti",
                textTerm: "App.Header.Viestinta.Posti"
            })
        }

        if (pageUtils.isMenuOnWhiteList("TVJaRadio")) {
            linkArray.push({
                to: "/Viestinta/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.Header.Viestinta.TVJaRadio"
            })
        }

        if (pageUtils.isMenuOnWhiteList("ViatJaHairiot")) {
            linkArray.push({
                to: "/Viestinta/ViatJaHairiot",
                pageName: "ViatJaHairiot",
                textTerm: "App.Header.Viestinta.ViatJaHairiot"
            })
        }

        if (pageUtils.isMenuOnWhiteList("Radiomikrofonitaajuudet")) {
            linkArray.push({
                to: "/Viestinta/Radiomikrofonitaajuudet",
                pageName: "Radiomikrofonitaajuudet",
                textTerm: "App.Header.Viestinta.Radiomikrofonitaajuudet"
            })
        }

        if (pageUtils.isMenuOnWhiteList("Bittimittari")) {
            linkArray.push({
                to: "/Viestinta/Bittimittari",
                pageName: "Bittimittari",
                textTerm: "App.Header.Viestinta.Bittimittari"
            })
        }

        return linkArray
    }

    getLiikenneLinks(): Array<any> {
        const pageUtils = new PageWhitelistUtils()
        const linkArray: Array<any> = []

        if (pageUtils.isMenuOnWhiteList("Tieliikenne")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.Header.Liikenne.Tieliikenne"
            })
        }

        if (pageUtils.isMenuOnWhiteList("Vesiliikenne")) {
            linkArray.push({
                to: "/Liikenne/Vesiliikenne",
                pageName: "Vesiliikenne",
                textTerm: "App.Header.Liikenne.VesiLiikenne"
            })
        }

        if (pageUtils.isMenuOnWhiteList("Infokartat")) {
            linkArray.push({
                to: "/Liikenne/Infokartat",
                pageName: "Infokartat",
                textTerm: "App.LeftSlot.Header.Infokartat"
            })
        }

        return linkArray
    }

    getEtusivuLinkObject(): Array<any> {
        const linkArray: Array<any> = []

        linkArray.push({
            to: "/",
            pageName: "",
            textTerm: "App.Header.Etusivu"
        })

        return linkArray
    }

    getViestintaLinksWithSubtopics(): Array<any> {
        const pageUtils = new PageWhitelistUtils()
        const linkArray: Array<any> = []

        // LAAJAKAISTA JA PUHELIN
        if (pageUtils.isMenuOnWhiteList("LaajakaistaJaPuhelin")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.Header.Viestinta.LaajakaistaJaPuhelin"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("KiinteanLaajakaistanSaatavuus")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.LaajakaistaJaPuhelin.RadioList.KiinteänLaajakaistaverkonNopeus",
                subTopic: "KiinteanLaajakaistanSaatavuus",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("MobiiliverkonKattavuus")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.LaajakaistaJaPuhelin.RadioList.MobiiliverkonKattavuus",
                subTopic: "MobiiliverkonKattavuus",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("KiinteanVerkonSaatavuusRuuduilla")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.RightSlotHeaderTemplate.KiinteanVerkonSaatavuusRuuduillaHeader",
                subTopic: "KiinteanVerkonSaatavuusRuuduilla",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("OikeusPuhelinJaLaajakaistaLiittymaan")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.LaajakaistaJaPuhelin.RadioList.OikeusPuhelinJaLaajakaistaLiittymaan",
                subTopic: "OikeusPuhelinJaLaajakaistaLiittymaanPalvelutyypinMukaan",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("Laajakaistahankkeet")) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: "App.LaajakaistaJaPuhelin.RadioList.Laajakaistahankkeet",
                subTopic: "Laajakaistahankkeet",
                isSubTopic: true
            })
        }

        // LAAJAKAISTAJAPUHELIN INFOKARTAT
        const laajakaistaJaPuhelinInfokartat = store.getters.laajakaistaJaPuhelinInfokarttaRadioValues

        for (let i = 0; i < laajakaistaJaPuhelinInfokartat.length; i++) {
            linkArray.push({
                to: "/Viestinta/LaajakaistaJaPuhelin",
                pageName: "LaajakaistaJaPuhelin",
                textTerm: this.getInfokarttaLocalizedName(laajakaistaJaPuhelinInfokartat[i]),
                subTopic: laajakaistaJaPuhelinInfokartat[i].tunniste,
                isSubTopic: true
            })
        }

        // POSTI
        if (pageUtils.isMenuOnWhiteList("Posti")) {
            linkArray.push({
                to: "/Viestinta/Posti",
                pageName: "Posti",
                textTerm: "App.Header.Viestinta.Posti"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("PostiHaeToimipaikkoja")) {
            linkArray.push({
                to: "/Viestinta/Posti",
                pageName: "Posti",
                textTerm: "App.RadioList.SearchLocations",
                subTopic: "PostiHaeToimipaikkoja",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("PostiTarkasteleMaaraa")) {
            linkArray.push({
                to: "/Viestinta/Posti",
                pageName: "Posti",
                textTerm: "App.RadioList.NumberOfServicePoints",
                subTopic: "PostiTarkasteleMaaraa",
                isSubTopic: true
            })
        }

        // POSTI INFOKARTAT
        const postiInfokartat = store.getters.postiInfokarttaRadioValues
        for (let i = 0; i < postiInfokartat.length; i++) {
            linkArray.push({
                to: "/Viestinta/Posti",
                pageName: "Posti",
                textTerm: this.getInfokarttaLocalizedName(postiInfokartat[i]),
                subTopic: postiInfokartat[i].tunniste,
                isSubTopic: true
            })
        }

        // TV JA RADIO
        if (pageUtils.isMenuOnWhiteList("TVJaRadio")) {
            linkArray.push({
                to: "/Viestinta/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.Header.Viestinta.TVJaRadio"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("TVPeittoalueet")) {
            linkArray.push({
                to: "/Liikenne/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.TVJaRadio.RadioList.AntenniTVLahetintenPeittoalueet",
                subTopic: "TVPeittoalueet",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("RadioPeittoalueet")) {
            linkArray.push({
                to: "/Liikenne/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.TVJaRadio.RadioList.RadiokanavienPeittoalueet",
                subTopic: "RadioPeittoalueet",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("AntenniTVSaatavuus")) {
            linkArray.push({
                to: "/Liikenne/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.TVJaRadio.RadioList.AntenniTVSaatavuusTietyssaPaikassa",
                subTopic: "AntenniTVSaatavuus",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("RadioasemienKuuluvuus")) {
            linkArray.push({
                to: "/Liikenne/TVJaRadio",
                pageName: "TVJaRadio",
                textTerm: "App.TVJaRadio.RadioList.RadioasemienKuuluvuusTietyssaPaikassa",
                subTopic: "RadioasemienKuuluvuus",
                isSubTopic: true
            })
        }

        // VIAT JA HÄIRIÖT
        if (pageUtils.isMenuOnWhiteList("ViatJaHairiot")) {
            linkArray.push({
                to: "/Viestinta/ViatJaHairiot",
                pageName: "ViatJaHairiot",
                textTerm: "App.Header.Viestinta.ViatJaHairiot"
            })
        }

        // RADIOMIKROFONITAAJUUDET
        if (pageUtils.isMenuOnWhiteList("Radiomikrofonitaajuudet")) {
            linkArray.push({
                to: "/Viestinta/Radiomikrofonitaajuudet",
                pageName: "Radiomikrofonitaajuudet",
                textTerm: "App.Header.Viestinta.Radiomikrofonitaajuudet"
            })
        }

        // BITTIMITTARI
        if (pageUtils.isMenuOnWhiteList("Bittimittari")) {
            linkArray.push({
                to: "/Viestinta/Bittimittari",
                pageName: "Bittimittari",
                textTerm: "App.Header.Viestinta.Bittimittari"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("BittimittariVuorokaudenaikaanPohjautuvatTiedot")) {
            linkArray.push({
                to: "/Viestinta/Bittimittari",
                pageName: "Bittimittari",
                textTerm: "App.RightSlotHeaderTemplate.BittimittariVuorokaudenaikaanPohjautuvatTiedotHeader",
                subTopic: "BittimittariVuorokaudenaikaanPohjautuvatTiedot",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("BittimittariOperaattorikohtaisetTiedot")) {
            linkArray.push({
                to: "/Viestinta/Bittimittari",
                pageName: "Bittimittari",
                textTerm: "App.RightSlotHeaderTemplate.BittimittariOperaattorikohtaisetTiedotHeader",
                subTopic: "BittimittariOperaattorikohtaisetTiedot",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("BittimittariVuorokaudenaikaanPohjautuvatRuudut")) {
            linkArray.push({
                to: "/Viestinta/Bittimittari",
                pageName: "Bittimittari",
                textTerm: "App.RightSlotHeaderTemplate.BittimittariVuorokaudenaikaanPohjautuvatRuudutHeader",
                subTopic: "BittimittariVuorokaudenaikaanPohjautuvatRuudut",
                isSubTopic: true
            })
        }

        return linkArray
    }

    getLiikenneLinksWithSubtopics(): Array<any> {
        const pageUtils = new PageWhitelistUtils()
        const linkArray: Array<any> = []

        // TIELIIKENNE
        if (pageUtils.isMenuOnWhiteList("Tieliikenne")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.Header.Liikenne.Tieliikenne"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("LupaJaRekisterointitoimipaikat")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.LupaJaRekisterointiPaikat",
                subTopic: "LupaJaRekisterointitoimipaikat",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("EnsirekisteroidytHenkiloAutot")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.EnsirekisteroidytHenkiloAutot",
                subTopic: "EnsirekisteroidytHenkiloAutot",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("EnsirekisteroidytHenkiloAutotPaastot")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.EnsirekisteroidytHenkiloAutotPaastot",
                subTopic: "EnsirekisteroidytHenkiloAutotPaastot",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("LiikennekaytossaHenkiloAutot")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.LiikennekaytossaHenkiloAutot",
                subTopic: "LiikennekaytossaHenkiloAutot",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("LiikennekaytossaHenkiloAutotKeskiIka")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.LiikennekaytossaHenkiloAutotKeskiIka",
                subTopic: "LiikennekaytossaHenkiloAutotKeskiIka",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("Liikenneonnettomuudet")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.Liikenneonnettomuudet",
                subTopic: "Liikenneonnettomuudet",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("MyonnetytTaksiluvat")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.Taksiluvat",
                subTopic: "MyonnetytTaksiluvat",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("VoimassaOlevatAjokortit")) {
            linkArray.push({
                to: "/Liikenne/Tieliikenne",
                pageName: "Tieliikenne",
                textTerm: "App.TieLiikenne.RadioList.VoimassaOlevatAjokortit",
                subTopic: "VoimassaOlevatAjokortit",
                isSubTopic: true
            })
        }

        // VESILIIKENNE
        if (pageUtils.isMenuOnWhiteList("Vesiliikenne")) {
            linkArray.push({
                to: "/Liikenne/Vesiliikenne",
                pageName: "Vesiliikenne",
                textTerm: "App.Header.Liikenne.VesiLiikenne"
            })
        }

        if (pageUtils.isSubjectOnWhiteList("Rekisterointitoimipaikat")) {
            linkArray.push({
                to: "/Liikenne/Vesiliikenne",
                pageName: "Vesiliikenne",
                textTerm: "App.VesiLiikenne.SubjectRadioList.LupaJaRekisterointiPaikat",
                subTopic: "Rekisterointitoimipaikat",
                isSubTopic: true
            })
        }

        if (pageUtils.isSubjectOnWhiteList("RekisteroidytVesikulkuneuvot")) {
            linkArray.push({
                to: "/Liikenne/Vesiliikenne",
                pageName: "Vesiliikenne",
                textTerm: "App.VesiLiikenne.SubjectRadioList.RekisteroidytVesikulkuneuvot",
                subTopic: "RekisteroidytVesikulkuneuvot",
                isSubTopic: true
            })
        }

        // INFOKARTAT
        if (pageUtils.isMenuOnWhiteList("Infokartat")) {
            linkArray.push({
                to: "/Liikenne/Infokartat",
                pageName: "Infokartat",
                textTerm: "App.LeftSlot.Header.Infokartat"
            })
        }

        const infokartat = store.getters.liikenneInfokarttaRadioValues
        for (let i = 0; i < infokartat.length; i++) {
            linkArray.push({
                to: "/Liikenne/Infokartat",
                pageName: "Infokartat",
                textTerm: this.getInfokarttaLocalizedName(infokartat[i]),
                subTopic: infokartat[i].tunniste,
                isSubTopic: true
            })
        }

        return linkArray
    }

    getEtusivuLink(): string | undefined {
        return "/" + utils.getCurrentSubdomain()
    }

    getInfokarttaLocalizedName(infokartta: any) : string {
        const lang = store.getters.activeLang
        if (lang === "fi") {
            return infokartta.nimifi
        }
        else if (lang === "sv") {
            return infokartta.nimisv
        }
        else if (lang === "en") {
            return infokartta.nimien
        }
        return ""
    }
}
